// extracted by mini-css-extract-plugin
module.exports = {"container":"_92a6e9e6","imageLinkWrapper":"_ae188015","imageWrapper":"_abee2ab5","image":"_38c790c6","info":"_1347f8af","title":"_9121c481","price":"_9b37de6c"};